import { render, staticRenderFns } from "./RoundInformationHeader.vue?vue&type=template&id=804b4554&scoped=true&"
import script from "./RoundInformationHeader.vue?vue&type=script&lang=js&"
export * from "./RoundInformationHeader.vue?vue&type=script&lang=js&"
import style0 from "./RoundInformationHeader.vue?vue&type=style&index=0&id=804b4554&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804b4554",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})
